<template>
	<div class="p4">
		<!-- Reject Reason -->
		<core-form-input
			id="rejectedReason"
			componentName="j-base-multi-select"
			name="rejectedReason"
			:label="$t('rejected_reason')"
			:options="rejectionOptions"
			v-model="rejectionReasons"
			:allowLocalSearch="true"
		/>

		<!-- Remarks/Comments -->
		<core-form-input
			componentName="j-base-input-long-text"
			id="rejectionRemarks"
			name="rejectionRemarks"
			class="mt8"
			:label="this.$t('remarks')"
			v-model="rejectionRemarks"
			v-validate="'required'"
		/>

		<!-- Toggle for sending cancellation email to client -->
		<core-form-input
			componentName="j-base-radios"
			name="sendEmailToggle"
			class="mt8"
			:label="this.$t('send_rejection_email')"
			v-model="sendEmailToggle"
			:options="[
				{ name: $t('yes'), value: 'yes' },
				{ name: $t('no'), value: 'no' }
			]"
		/>
		<j-button class="mt8" type="error" @click="rejectQuote" action="rejectQuote">{{ this.$t("reject_quote") }}</j-button>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "../api/"
import get from "lodash.get"
import { decline } from "@/clientSettings/templates/asia_uat.js"
export default {
	components: {
		CoreFormInput,
		JButton
	},
	props: {
		payload: {
			type: Object,
			required: true
		},
		id: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			sendEmailToggle: "yes", // toggle to send email to client or not
			rejectionRemarks: null, // remarks inputed by user
			rejectionReasons: [], // reasons selected by user
			rejectionOptions: [] // list of options that user can select as reason
		}
	},
	methods: {
		// initalize rejectionRemarks and rejectioReasons with data from payload
		// used to update rejection info but also populating fields with existing data
		initialize() {
			const updatedRemarks = this.payload.rejectionRemarks
			const updatedReasons = get(this, "payload.rejectionCodes", {})
			this.rejectionRemarks = updatedRemarks
			if (updatedReasons !== null)
				this.rejectionReasons = [
					...updatedReasons.map(item => item.code)
				]
		},
		// Fetch selectable options for Rejection Reason from api
		async readRejectionSettings() {
			// get plan from the fetchedQuote
			const fetchedPlan = this.payload.acceptedOffer.product
				.productId.plan
			// fetch rejectionSettings for specific product
			const res = await api.readRejectionSettings({
				where: { productId: { plan: fetchedPlan } }
			})
			const code = get(
				res,
				"data.products_2.list[0].rejectionSettings.codeNames",
				[]
			)
			this.rejectionOptions = code.map(item => {
				return {
					name: `${item.code} - ${item.name}`,
					value: item.code
				}
			})
		},
		composeEmailPayload() {
			// Product Name
			const productName = get(
				this,
				"payload.offers[0].product.name",
				""
			)
			// Policy Number
			const policyNumber = this.id
			// Primary Holder
			const primaryHolder = get(this, "payload.holder.name", "")
			// Array of Objects for otherHolders
			const otherHoldersArray = get(
				this,
				"payload.otherHolders",
				[]
			)
			// Storing otherHolders names only
			const otherHolders =
				otherHoldersArray !== null
					? otherHoldersArray.map(item => item.name)
					: []
			// Combining names of primary holder and other holders into one array
			const policyHolders = [primaryHolder, ...otherHolders]
			// Insured person array
			const insuredArray = get(this, "payload.insured", [])
			// Storing insured person name only
			const insuredName =
				insuredArray !== null
					? insuredArray.map(item => item.name)
					: ""
			// createdAt date of quote
			const applicationDate = get(this, "payload.createdAt", "")
			// fetch nameKey of rejection options which matches the users selected rejection reason
			const rejectionCodes = this.rejectionOptions
				.filter(option =>
					this.rejectionReasons.includes(option.value)
				)
				.map(item => item.name)
			return {
				productName,
				policyNumber,
				policyHolders,
				insuredName,
				applicationDate,
				rejectionCodes
			}
		},
		async sendRejectionEmail(email) {
			const payload = this.composeEmailPayload()
			const res = await api.sendNotification({
				input: {
					type: "rejection",
					emailMessage: decline({
						toEmail: email,
						...payload
					})
				}
			})
		},
		async rejectQuote() {
			// TODO: Check if reason of rejection has been selected
			// Change policy status to "REJECTED" or "CANCELLED"
			// Store reason of rejection in `rejectedReasons`
			let policyId = this.id
			let codes = this.rejectionReasons
			let remarks = this.rejectionRemarks
			const res = await api.rejectQuote({
				policyId,
				codes,
				remarks
			})
			let contacts = this.payload.holder.contacts
			// 1. Check if client has an email address && if sendEmailToggle is true
			// 2. Filter contacts array of holder and get all contact with type "email"
			// 3. Create a new array with values that passed filter
			// 4. Resolve all promises from array and send rejection email to every email
			if (contacts !== null && this.sendEmailToggle === "yes") {
				const holderEmails = contacts
					.filter(item => {
						if (item.type === "email") return item.value
					})
					.map(item => item.value)
				Promise.all(holderEmails).then(result =>
					result.forEach(item =>
						this.sendRejectionEmail(item)
					)
				)
			}
			// Emit to parent
			this.$emit("rejected")
			// Toast Message
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("rejected")
				}
			})
		}
	},
	mounted() {
		this.initialize()
		this.readRejectionSettings()
	}
}
</script>